import postcss from "postcss";
import postcssNesting from "postcss-nesting";
import postcssJs from "postcss-js";
const jssToCSS = ({ styleObj }) => {
  const result = postcss([postcssNesting]).process(styleObj, {
    parser: postcssJs
  });
  return result.css;
};
export {
  jssToCSS
};
//# sourceMappingURL=jssToCSS.js.map
